// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"530":"42d8c4a4","676":"ed950678","788":"68ded98e","881":"28739338","962":"75918eca","970":"98d8ceb1","977":"fcc10669"}[chunkId] + ".chunk.js";
};